import { FC } from 'react';
import { useImageUrl, UseImageUrlBaseProps } from '../../hooks/useImageUrl';

export interface CompetitionLogoProps extends Partial<UseImageUrlBaseProps> {
  className?: string;
  competition: string;
  fallbackCompetition?: string;
}

export const CompetitionLogo: FC<CompetitionLogoProps> = ({
  className,
  competition,
  fallbackCompetition = '',
  ext = 'png',
  hostname = 'https://engagecraftfantasydev.blob.core.windows.net',
  pathname = 'competitions/logos',
}) => {
  const { url, value, onError } = useImageUrl({
    value: competition,
    fallbackValue: fallbackCompetition,
    hostname,
    pathname,
    ext,
  });

  return (
    <picture>
      <img className={className} src={url.toString()} alt={value} onError={onError} />
    </picture>
  );
};
